"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var createBistate_1 = require("../createBistate");

var createStore_1 = __importDefault(require("../createStore"));

var util_1 = require("../util");

var useUpdate_1 = __importDefault(require("./useUpdate"));

function useBistate(initialState, currentState) {
  var store = react_1.useMemo(function () {
    if (util_1.isFunction(initialState)) {
      initialState = initialState();
    }

    return createStore_1.default(initialState);
  }, []);
  var update = useUpdate_1.default(); // commit change to get next state if state has been mutated

  createBistate_1.unlock(store.getState());
  var state = store.getState(); // lock state, and trigger update when mutate state

  createBistate_1.lock(state, update);
  return createBistate_1.isBistate(currentState) ? currentState : state;
}

exports.default = useBistate;